{
  "Approve": "核准",
  "DeleteReminder": "刪除提醒",
  "DismissAlert": "關閉",
  "DismissReminder": "關閉提醒",
  "EditReminder": "編輯提醒",
  "High": "高",
  "Reject": "拒絕",
  "RemindMe15Min": "15 分鐘後再提醒我",
  "RemindMe5Min": "5 分鐘後再提醒我",
  "RemindMe60Min": "1 小時後再提醒我",
  "RemindMeTomorrow": "明天再提醒我",
  "Snooze": "提醒我",
  "markAsRead": "標記為已讀",
  "markAsUnread": "標記為未讀"
}
